/**
 * 플레이 그룹 삭제 가드 — 미존재/보드 소속 시 차단(A방식) 단위 테스트.
 */
import { assertPlayGroupDeletable } from './play-group-delete-guard'

const t = (key: string, params?: Record<string, unknown>) => (params ? `${key}(${JSON.stringify(params)})` : key)

describe('assertPlayGroupDeletable', () => {
  test('플레이 그룹이 없으면 not-found 로 throw', () => {
    expect(() => assertPlayGroupDeletable(null, t)).toThrow('error.play group not found')
    expect(() => assertPlayGroupDeletable(undefined, t)).toThrow('error.play group not found')
  })

  test('소속 보드가 있으면 삭제 차단 throw (count 포함)', () => {
    expect(() => assertPlayGroupDeletable({ boards: [{ id: 'b1' }, { id: 'b2' }] }, t)).toThrow(
      'error.play group has boards'
    )
    expect(() => assertPlayGroupDeletable({ boards: [{ id: 'b1' }, { id: 'b2' }] }, t)).toThrow('"count":2')
  })

  test('boards 없음/빈 배열이면 통과(throw 없음)', () => {
    expect(() => assertPlayGroupDeletable({}, t)).not.toThrow()
    expect(() => assertPlayGroupDeletable({ boards: [] }, t)).not.toThrow()
  })

  test('미존재가 보드-소속보다 우선', () => {
    expect(() => assertPlayGroupDeletable(null, t)).toThrow('error.play group not found')
  })
})
